import { render } from "./UiCheckboxInput.vue?vue&type=template&id=99ee2fda&ts=true"
import script from "./UiCheckboxInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiCheckboxInput.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiCheckboxInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "99ee2fda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('99ee2fda', __exports__)) {
    api.reload('99ee2fda', __exports__)
  }
  
  module.hot.accept("./UiCheckboxInput.vue?vue&type=template&id=99ee2fda&ts=true", () => {
    api.rerender('99ee2fda', render)
  })

}


export default __exports__